var exports = {
  "zr": "root__E5CvMi",
  "DD": "title__afOHYT",
  "R_": "heading__QL1dZ7",
  "YB": "columns__P_HShN",
  "En": "columnHeaderLabel__7TUkD7",
  "fi": "column__X8-t5W",
  "fV": "subheading__z4oXUh",
};

module.exports = exports;
